export default [
    {
        name: "royal",
        path: "/royal",
        component: () => import("@/modules/BattleRoyal"),
    },
];
